const TelaInicio = () =>
  import(/* webpackChunkName: "tela-principal" */ "@/pages/TelaPrincipal");

const NovoCadastro = () =>
  import(/* webpackChunkName: "lista-cadastros" */ "@/pages/Cadastro/Novo");

const ListaCadastros = () =>
  import(/* webpackChunkName: "lista-cadastros" */ "@/pages/Cadastro/Lista");

const ImprimirProtocolo = () =>
  import(
    /* webpackChunkName: "imprimir-protocolo" */ "@/pages/Protocolo/Imprimir"
  );

const BuscarProtocolo = () =>
  import(/* webpackChunkName: "buscar-protocolo" */ "@/pages/Protocolo/Buscar");

const ProcessoInscricao = () =>
  import(/* webpackChunkName: "Processo-Incrição" */ "@/pages/Processo/index");

const NovoProcesso = () =>
  import(
    /* webpackChunkName: "Processo-Incrição" */ "@/pages/Processo/NovoProcesso"
  );

const EditarProcesso = () =>
  import(
    /* webpackChunkName: "Processo-Incrição" */ "@/pages/Processo/EditarProcesso"
  );

const ConsultaPlantao = () =>
  import(
    /* webpackChunkName: "ConsultaPlantao" */ "@/pages/PLANTAO_DE_FERIAS/consulta-plantao/ConsultaPlantao"
  );

const PlantaoFerias = () =>
  import(
    /* webpackChunkName: "PlantaoFerias" */ "@/pages/PLANTAO_DE_FERIAS/plantao/PlantaoFerias"
  );

const ImprimirProtocoloPlantao = () =>
  import(
    /* webpackChunkName: "imprimir-protocolo" */ "@/pages/ProtocoloPlantao/Imprimir"
  );

const BuscarProtocoloPlantao = () =>
  import(
    /* webpackChunkName: "buscar-protocolo" */ "@/pages/ProtocoloPlantao/Buscar"
  );

const BuscarEncaminhamento = () =>
  import(
    /* webpackChunkName: "buscar-encaminhamento" */ "@/pages/PLANTAO_DE_FERIAS/encaminhamento/Buscar"
  );
const ConsultaPlantaoUnidades = () =>
  import(
    /* webpackChunkName: "Processo-Incrição" */ "@/pages/consulta-plantao/ConsultaPlantaoUnidades"
  );

const ImprimirEncaminhamento = () =>
  import(
    /* webpackChunkName: "imprimir-encaminhamento" */ "@/pages/PLANTAO_DE_FERIAS/encaminhamento/Imprimir"
  );

const RelatorioConsultaVaga = () =>
  import(
    /* webpackChunkName: "imprimir-encaminhamento" */ "@/pages/relatorios/consulta-vaga"
  );

const routes = [
  {
    path: "/",
    name: "Tela Inícial",
    component: TelaInicio
  },
  {
    path: "/novo-cadastro",
    name: "Novo Cadastro",
    component: NovoCadastro
  },
  {
    path: "/cadastros",
    name: "Cadastros",
    component: ListaCadastros
  },
  {
    path: "/protocolo",
    name: "Imprimir Protocolo",
    component: BuscarProtocolo
  },
  {
    path: "/protocolo/:id",
    name: "Impressão de Protocolo",
    component: ImprimirProtocolo,
    props: true
  },
  {
    path: "/processos",
    name: "Processo de Inscrição",
    component: ProcessoInscricao
  },
  {
    path: "/processos/novo",
    name: "Novo processo",
    component: NovoProcesso
  },
  {
    path: "/processos/editar/:id",
    name: "Editar processo",
    component: EditarProcesso,
    props: true
  },
  {
    path: "/consulta-plantao",
    name: "Consulta do Plantão de Férias",
    component: ConsultaPlantao
  },
  {
    path: "/plantao",
    name: "Plantão de Férias",
    component: PlantaoFerias
  },
  {
    path: "/protocolo-plantao",
    name: "Termo de Compromisso",
    component: BuscarProtocoloPlantao
  },
  {
    path: "/protocolo-plantao/:id",
    name: "Impressão de Protocolo - Plantão de Férias",
    component: ImprimirProtocoloPlantao,
    props: true
  },
  {
    path: "/encaminhamento-plantao",
    name: "Protocolo de Encaminhamento",
    component: BuscarEncaminhamento
  },
  {
    path: "/consulta-plantao-unidades",
    name: "Plantão de Férias das Unidades",
    component: ConsultaPlantaoUnidades
  },
  {
    path: "/encaminhamento-plantao/:id",
    name: "Protocolo de Encaminhamento - Plantão de Férias",
    component: ImprimirEncaminhamento,
    props: true
  },
  {
    path: "/relatorio-vagas",
    name: "Relatório de Vagas",
    component: RelatorioConsultaVaga
  }
];

export default routes;
